import { getActiveFilter } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { useStateHooks } from '../../../state'
import { TableName } from '../../../tables'
import { useLoaders } from '../../common'
import { useSystemStateHooks } from '../../system'
import { ExpenseType } from '../state/types'

export const useExpenseTypeLoaders = () => {
    const systemHooks = useSystemStateHooks()
    const { getList, find } = useStateHooks()

    const loaders = useLoaders()

    return (companyId = systemHooks.companyId) => {
        const findAllExpenseTypes = (active = false) => getList(TableName.EXPENSE_TYPES, active) as ExpenseType[]

        const findExpenseType = (id?: string) => find(TableName.EXPENSE_TYPES, id) as O<ExpenseType>

        const loadAllExpenseTypes = async (active = false) => {
            const { loadMultiple } = loaders(companyId)
            const options = active ? getActiveFilter() : undefined
            const response = await loadMultiple(TableName.EXPENSE_TYPES, options)
            return response.dataTypes as ExpenseType[]
        }

        const loadExpenseType = (
            id: string,
            dbRequest = false
        ) => {
            const { load } = loaders(companyId)
            return load(TableName.EXPENSE_TYPES, id, dbRequest) as Promise<O<ExpenseType>>
        }

        return {
            findAllExpenseTypes,
            findExpenseType,
            loadAllExpenseTypes,
            loadExpenseType
        }
    }
}
